import { Routes, Route } from 'react-router-dom';
import DisplayRouting from './components/routing/DisplayRouting';
import ResolveRouting from './components/routing/ResolveRouting';
function AppRouting() {
    return (
        <Routes>
            <Route path="displayRouting" element={<DisplayRouting />} />
			<Route path="resolveRouting" element={<ResolveRouting />} />
        </Routes>
    );
}

export default AppRouting;